import { addDoc, collection, doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function submitNps(data) {
  await addDoc(collection(db, 'artifacts', appId, 'public', 'data', 'portal_nps'), {
    clientId: data.clientId,
    clientName: data.clientName || null,
    workspaceId: data.workspaceId,
    stage: data.stage,
    score: data.score,
    comment: data.comment || null,
    createdAt: serverTimestamp(),
  });
}

export async function markWorkspaceNpsDone(workspaceId, stage) {
  await updateDoc(
    doc(db, 'artifacts', appId, 'public', 'data', 'autos_workspaces', workspaceId),
    { npsCompletedForStage: stage }
  );
}
